import React from "react";

export const Button = ({
    children,
    onClick,
    variant = "contained",
    color = "primary",
    size = "md",
    disabled = false,
    className = "",
}) => {
    let cn = "block focus:ring-2 rounded text-center";

    if (variant === "contained") {
        if (color === "gray") {
            if (disabled) {
                cn += " text-white bg-gray-300 ";
            } else {
                cn +=
                    " text-white bg-gray-400 hover:bg-gray-500 focus:ring-4 focus:ring-gray-300";
            }
        } else if (color === "blue") {
            if (disabled) {
                cn += " text-white bg-blue-300 ";
            } else {
                cn += " text-white bg-blue-700 hover:bg-blue-800 focus:ring-blue-300";
            }
        } else {
            if (disabled) {
                cn += " text-white bg-primary-300 ";
            } else {
                cn +=
                    " text-white bg-primary-500 hover:bg-primary-400 focus:ring-4 focus:ring-primary-300";
            }
        }
    } else if (variant === "outlined") {
        if (color === "blue") {
            if (disabled) {
                cn += " text-white bg-blue-300 ";
            } else {
                cn += " text-white bg-blue-700 hover:bg-blue-800 focus:ring-blue-300";
            }
        } else {
            if (disabled) {
                cn += " text-primary-300 border-2 border-primary-300 ";
            } else {
                cn +=
                    " text-primary-500 border-2 border-primary-500 hover:bg-primary-500 hover:text-white focus:ring-4 focus:ring-primary-300";
            }
        }
    }

    if (disabled) {
        cn += " cursor-not-allowed";
    }

    if (size === "xs") {
        cn += " text-xs px-2 py-1.5";
    } else if (size === "sm") {
        cn += " text-sm px-3 py-2";
    } else if (size === "md") {
        cn += " text-sm px-4 py-2.5 font-semibold";
    } else if (size === "lg") {
        cn += " text-base px-5 py-3 font-semibold";
    } else if (size === "xl") {
        cn += " text-lg px-6 py-3.5 font-bold";
    }

    if (className) {
        cn += " " + className;
    }

    return (
        <button type="button" onClick={onClick} className={cn}>
            {children}
        </button>
    );
};
